module.exports = __webpack_public_path__ + "assets/img/bg-prize-1.567fa573.png";